"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9390],{

/***/ 69685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59864);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var ImageList = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ImageList(props, ref) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$gap = props.gap,
      gapProp = _props$gap === void 0 ? 4 : _props$gap,
      _props$rowHeight = props.rowHeight,
      rowHeightProp = _props$rowHeight === void 0 ? 180 : _props$rowHeight,
      spacing = props.spacing,
      style = props.style,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "gap", "rowHeight", "spacing", "style"]);

  var gap = spacing || gapProp;
  var rowHeight = cellHeight || rowHeightProp;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
    ref: ref,
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      margin: -gap / 2
    }, style)
  }, other), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
      return null;
    }

    if (false) {}

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "".concat(100 / cols * childCols, "%"),
        height: rowHeight === 'auto' ? 'auto' : rowHeight * childRows + gap,
        padding: gap / 2
      }, child.props.style)
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiImageList'
})(ImageList));

/***/ }),

/***/ 58108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74902);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79437);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52543);
/* harmony import */ var _utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83711);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  item: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var ImageListItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ImageListItem(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    ensureImageCover(imgRef.current, classes);
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.item
  }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
      return null;
    }

    if (child.type === 'img' || (0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(child, ['Image'])) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiImageListItem'
})(ImageListItem));

/***/ }),

/***/ 46869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66987);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className"]);

  var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),

/***/ 81860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52543);






var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

var ListItemSecondaryAction = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemSecondaryAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction));

/***/ }),

/***/ 63605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ContentCardInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(282);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_common_GameIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66610);
/* harmony import */ var components_navigation_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18780);






var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        button: {
            padding: "0 !important",
            width: 201,
            height: 176,
            boxShadow: "0px 1px 18px rgba(0, 0, 0, 0.12)",
            margin: theme.spacing(4, 1, 4, 1)
        },
        label: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            textTransform: "none",
            height: "100%"
        }
    };
});
var ContentCardInfo = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, blurImage = param.blurImage, imagesAboveFold = param.imagesAboveFold;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        height: "auto",
        p: 2,
        bgcolor: "background.paper",
        flex: 1,
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_GameIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                src: image,
                alt: "".concat(subTitle, " icon"),
                blurDataURL: blurImage,
                imagesAboveFold: imagesAboveFold
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        textAlign: "left",
                        clone: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "subtitle1",
                            component: "span",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: title
                            })
                        })
                    }),
                    subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        textAlign: "left",
                        width: "100%",
                        clone: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "subtitle2",
                            color: "textSecondary",
                            component: "span",
                            children: subTitle
                        })
                    })
                ]
            })
        ]
    });
};
var ContentCardMedium = function(param) {
    var title = param.title, subTitle = param.subTitle, bannerImage = param.bannerImage, image = param.image, blurImage = param.blurImage, onClick = param.onClick, href = param.href, imagesAboveFold = param.imagesAboveFold;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        component: href ? components_navigation_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C : "button",
        href: href,
        classes: {
            root: classes.button,
            label: classes.label
        },
        onClick: href ? undefined : onClick,
        "data-testid": "game",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                width: "100%",
                height: 112,
                position: "relative",
                overflow: "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: bannerImage,
                    alt: "".concat(title, " image"),
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: blurImage,
                    placeholder: "blur",
                    priority: imagesAboveFold
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentCardInfo, {
                title: title,
                subTitle: subTitle,
                image: image,
                blurImage: blurImage,
                imagesAboveFold: imagesAboveFold
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentCardMedium);


/***/ }),

/***/ 71074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69685);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58108);



var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        imageList: {
            flexWrap: "nowrap",
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: "translateZ(0)"
        },
        imageListNoPadding: {
            flexWrap: "nowrap",
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: "translateZ(0)"
        },
        imageListItem: {
            width: "auto !important",
            padding: "0 !important"
        },
        firstImage: {
            "& a": {
                marginLeft: theme.spacing(4)
            }
        },
        lastImage: {
            "& a": {
                marginRight: theme.spacing(4)
            }
        }
    };
});
var HorizontalList = function(param) {
    var children = param.children, id = param.id, _omitPadding = param.omitPadding, omitPadding = _omitPadding === void 0 ? false : _omitPadding;
    var classes = useStyles();
    var items = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: omitPadding ? classes.imageListNoPadding : classes.imageList,
        rowHeight: "auto",
        gap: 8,
        children: items.map(function(child, key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                classes: {
                    root: classes.imageListItem
                },
                className: key === 0 ? classes.firstImage : key === items.length - 1 ? classes.lastImage : undefined,
                children: typeof child === "string" || typeof child === "number" ? child : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child)
            }, "".concat(id, "-").concat(key));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalList);


/***/ }),

/***/ 65943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Section_GameSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(22291);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(79450);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/utils/game.utils.ts
var game_utils = __webpack_require__(62698);
// EXTERNAL MODULE: ./src/utils/routes.utils.ts
var routes_utils = __webpack_require__(24039);
// EXTERNAL MODULE: ./src/constants/blurBase64.ts
var blurBase64 = __webpack_require__(56278);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(19910);
// EXTERNAL MODULE: ./src/services/api/definitions/game.definitions.ts
var game_definitions = __webpack_require__(45362);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/@navigation/Link/Link.tsx
var Link = __webpack_require__(18780);
;// CONCATENATED MODULE: ./src/components/@common/ContentCard/ExtraSmall/ContentCardExtraSmall.tsx





var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            display: "-webkit-box",
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": 2,
            overflow: "hidden",
            height: "38px"
        },
        label: {
            display: "flex",
            flexDirection: "column",
            width: "96px",
            textTransform: "none",
            textAlign: "left"
        },
        button: {
            padding: 0,
            height: "100%",
            margin: theme.spacing(0, 1)
        }
    };
});
var ContentCardExtraSmall = function(param) {
    var title = param.title, image = param.image, blurImage = param.blurImage, href = param.href, imagesAboveFold = param.imagesAboveFold;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        classes: {
            label: classes.label,
            root: classes.button
        },
        component: href ? Link/* default */.C : "button",
        href: href,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                borderRadius: 12,
                width: "100%",
                height: 96,
                position: "relative",
                overflow: "hidden",
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    alt: "".concat(title, " image"),
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: blurImage,
                    placeholder: "blur",
                    priority: imagesAboveFold
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                classes: {
                    root: classes.root
                },
                variant: "subtitle2",
                component: "h2",
                children: title
            })
        ]
    });
};
/* harmony default export */ var ExtraSmall_ContentCardExtraSmall = (ContentCardExtraSmall);

// EXTERNAL MODULE: ./src/components/@common/ContentCard/Medium/ContentCardMedium.tsx
var ContentCardMedium = __webpack_require__(63605);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/ListItemSecondaryAction.js
var ListItemSecondaryAction = __webpack_require__(81860);
;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Small/ContentCardSmall.tsx





var ContentCardSmall_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        listItem: {
            paddingTop: 0,
            paddingBottom: 0,
            marginBottom: theme.spacing(2),
            paddingRight: 120
        },
        listItemSecondaryAction: {
            right: 0
        }
    };
});
var ContentCardSmall = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, buttonText = param.buttonText, explainerText = param.explainerText, blurImage = param.blurImage, href = param.href, imagesAboveFold = param.imagesAboveFold, disableAction = param.disableAction, onActionClick = param.onActionClick, onClick = param.onClick;
    var classes = ContentCardSmall_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
        className: classes.listItem,
        button: true,
        component: Link/* default */.C,
        href: href,
        "data-testid": "game",
        disableGutters: true,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    borderRadius: 12,
                    width: 64,
                    height: 64,
                    position: "relative",
                    overflow: "hidden",
                    mr: 3,
                    flexShrink: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        alt: "".concat(title, " image"),
                        layout: "fill",
                        objectFit: "cover",
                        blurDataURL: blurImage,
                        placeholder: "blur",
                        priority: imagesAboveFold
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemText/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        width: "100%",
                        clone: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            component: "p",
                            children: title
                        })
                    }),
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        component: "span",
                        color: "textSecondary",
                        children: subTitle
                    })
                ]
            }),
            onActionClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemSecondaryAction/* default */.Z, {
                className: classes.listItemSecondaryAction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    ml: 2,
                    flexShrink: 0,
                    flexGrow: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            color: "primary",
                            onClick: onActionClick,
                            size: "small",
                            disabled: disableAction,
                            children: buttonText
                        }),
                        explainerText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            color: "textSecondary",
                            children: explainerText
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Small_ContentCardSmall = (ContentCardSmall);

// EXTERNAL MODULE: ./src/components/@common/HorizontalList/HorizontalList.tsx
var HorizontalList = __webpack_require__(71074);
;// CONCATENATED MODULE: ./src/components/@game-detail/Section/GameSection.tsx
















var GameSection = function(param) {
    var data = param.data, _variant = param.variant, variant = _variant === void 0 ? "large" : _variant, id = param.id, imagesAboveFold = param.imagesAboveFold, _disablePadding = param.disablePadding, disablePadding = _disablePadding === void 0 ? false : _disablePadding, onClickItem = param.onClickItem;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var send = (0,useAnalytics/* useAnalytics */.z)().send;
    if (variant === "detail") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mx: disablePadding ? 0 : 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                children: data.map(function(game) {
                    var gamePrice = game.price.toLowerCase() === "free" ? intl.formatMessage({
                        id: "game.details.price.free"
                    }) : game.price;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Small_ContentCardSmall, {
                        title: game.name,
                        subTitle: game.collectionName,
                        image: game.smallTeaserImage,
                        buttonText: (0,game_utils/* isExternalGameProvider */.eP)(game.provider) ? intl.formatMessage({
                            id: "game.action.view"
                        }) : gamePrice,
                        blurImage: blurBase64/* default */.Z,
                        explainerText: game.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? intl.formatMessage({
                            id: "game.explainer_text.one_time_pay"
                        }) : intl.formatMessage({
                            id: "game.explainer_text.per_game_session"
                        }) // TODO: add all cases
                        ,
                        onClick: function() {
                            return onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(game);
                        },
                        onActionClick: game.contentType === game_definitions/* ContentType.game */.zc.game && (0,game_utils/* canPlayGame */.IS)(game) ? function() {
                            if (!(0,game_utils/* isExternalGameProvider */.eP)(game.provider)) {
                                send({
                                    event: events/* Events.gamePlayed */.z.gamePlayed,
                                    data: {
                                        game: {
                                            slug: game === null || game === void 0 ? void 0 : game.slugName
                                        }
                                    },
                                    withUser: true
                                });
                            }
                            router.push((0,routes_utils/* generatePath */.G)((0,game_utils/* isExternalGameProvider */.eP)(game.provider) ? routes/* Routes.gameDetails */.Z.gameDetails : routes/* Routes.game */.Z.game, {
                                slug: game.slugName
                            }));
                        } : undefined,
                        href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                            slug: game.slugName
                        }),
                        imagesAboveFold: imagesAboveFold,
                        disableAction: !isLoggedIn
                    }, game.id);
                })
            })
        });
    }
    if (variant === "small") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList/* default */.Z, {
            id: id,
            omitPadding: disablePadding,
            children: data.map(function(game) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraSmall_ContentCardExtraSmall, {
                    title: game.name,
                    image: game.smallTeaserImage,
                    blurImage: blurBase64/* default */.Z,
                    href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                        slug: game.slugName
                    }),
                    imagesAboveFold: imagesAboveFold
                }, game.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList/* default */.Z, {
        id: id,
        omitPadding: disablePadding,
        children: data.map(function(game, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCardMedium/* default */.Z, {
                title: game.name,
                subTitle: game.collectionName,
                bannerImage: game.largeTeaserImage,
                image: game.smallTeaserImage,
                blurImage: blurBase64/* default */.Z,
                href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                    slug: game.slugName
                }),
                imagesAboveFold: imagesAboveFold && index < 3
            }, game.id);
        })
    });
};
/* harmony default export */ var Section_GameSection = (GameSection);


/***/ }),

/***/ 49390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _GameSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _GameSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65943);



/***/ })

}]);